import script from "./detail-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-layout.vue?vue&type=script&setup=true&lang=js"

import "./detail-layout.vue?vue&type=style&index=0&id=6af070a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af070a0"]])

export default __exports__